export const strongMultiPages = [
  { href: "/strong-multi-page", text: "Home" },
  { href: "/strong-about", text: "About", className: "active" },
  { href: "/strong-services", text: "Services" },
  { href: "/strong-portfolio", text: "Portfolio" },
  { href: "/strong-blog", text: "Blog" },
  { href: "/strong-contact", text: "Contact" },
];
export const strongMultiPagesDark = [
  { href: "/strong-multi-page-dark", text: "Home" },
  { href: "/strong-about-dark", text: "About", className: "active" },
  { href: "/strong-services-dark", text: "Services" },
  { href: "/strong-portfolio-dark", text: "Portfolio" },
  { href: "/strong-blog-dark", text: "Blog" },
  { href: "/strong-contact-dark", text: "Contact" },
];
export const strongSinglePages = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const slickMultipages = [
  { href: "/slick-multi-page", text: "Home" },
  { href: "/slick-about", text: "About", class: "active" },
  { href: "/slick-services", text: "Services" },
  { href: "/slick-portfolio", text: "Portfolio" },
  { href: "/slick-blog", text: "Blog" },
  { href: "/slick-contact", text: "Contact" },
];
export const slickMultipagesDark = [
  { href: "/slick-multi-page-dark", text: "Home" },
  { href: "/slick-about-dark", text: "About", class: "active" },
  { href: "/slick-services-dark", text: "Services" },
  { href: "/slick-portfolio-dark", text: "Portfolio" },
  { href: "/slick-blog-dark", text: "Blog" },
  { href: "/slick-contact-dark", text: "Contact" },
];
export const slickOnepage = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const modernMultipage = [
  { id: 1, href: "/modern-multi-page", text: "Home" },
  { id: 2, href: "/modern-about", text: "About", className: "active" },
  { id: 3, href: "/modern-services", text: "Services" },
  { id: 4, href: "/modern-portfolio", text: "Portfolio" },
  { id: 5, href: "/modern-blog", text: "Blog" },
  { id: 6, href: "/modern-contact", text: "Contact" },
];
export const modernMultipageDark = [
  { id: 1, href: "/modern-multi-page-dark", text: "Home" },
  { id: 2, href: "/modern-about-dark", text: "About", className: "active" },
  { id: 3, href: "/modern-services-dark", text: "Services" },
  { id: 4, href: "/modern-portfolio-dark", text: "Portfolio" },
  { id: 5, href: "/modern-blog-dark", text: "Blog" },
  { id: 6, href: "/modern-contact-dark", text: "Contact" },
];

export const modernOnepage = [
  { href: "#home", text: "Home", className: "active", dataBtnAnimate: "y" },
  { href: "#about", text: "About", dataBtnAnimate: "y" },
  { href: "#services", text: "Services", dataBtnAnimate: "y" },
  { href: "#portfolio", text: "Portfolio", dataBtnAnimate: "y" },
  { href: "#blog", text: "Blog", dataBtnAnimate: "y" },
  { href: "#contact", text: "Contact", dataBtnAnimate: "y" },
];

export const gradientMultipage = [
  { href: "/gradient-multi-page", text: "Home", active: true },
  { href: "/gradient-about", text: "About", active: false },
  { href: "/gradient-services", text: "Services", active: false },
  { href: "/gradient-portfolio", text: "Portfolio", active: false },
  { href: "/gradient-blog", text: "Blog", active: false },
  { href: "/gradient-contact", text: "Contact", active: false },
];
export const gradientMultipageDark = [
  { href: "/gradient-multi-page-dark", text: "Home", active: true },
  { href: "/gradient-about-dark", text: "About", active: false },
  { href: "/gradient-services-dark", text: "Services", active: false },
  { href: "/gradient-portfolio-dark", text: "Portfolio", active: false },
  { href: "/gradient-blog-dark", text: "Blog", active: false },
  { href: "/gradient-contact-dark", text: "Contact", active: false },
];

export const gradientOnePage = [
  { href: "#home", text: "Home", className: "active", dataBtnAnimate: "y" },
  { href: "#about", text: "About", dataBtnAnimate: "y" },
  { href: "#services", text: "Services", dataBtnAnimate: "y" },
  { href: "#portfolio", text: "Portfolio", dataBtnAnimate: "y" },
  { href: "#blog", text: "Blog", dataBtnAnimate: "y" },
  { href: "#contact", text: "Contact", dataBtnAnimate: "y" },
];

export const fancyMultipage = [
  { href: "/fancy-multi-page", text: "Home", class: "active" },
  { href: "/fancy-about", text: "About" },
  { href: "/fancy-services", text: "Services" },
  { href: "/fancy-portfolio", text: "Portfolio" },
  { href: "/fancy-blog", text: "Blog" },
  { href: "/fancy-contact", text: "Contact" },
];

export const fancyMultipageDark = [
  { href: "/fancy-multi-page-dark", text: "Home", class: "active" },
  { href: "/fancy-about-dark", text: "About" },
  { href: "/fancy-services-dark", text: "Services" },
  { href: "/fancy-portfolio-dark", text: "Portfolio" },
  { href: "/fancy-blog-dark", text: "Blog" },
  { href: "/fancy-contact-dark", text: "Contact" },
];

export const fancyOnepage = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#pricing", text: "Pricing" },
  { href: "#contact", text: "Contact" },
];

export const elegantMultipage = [
  { href: "/elegant-multi-page", text: "Home" },
  { href: "/elegant-about", text: "About" },
  { href: "/elegant-services", text: "Services" },
  { href: "/elegant-portfolio", text: "Portfolio" },
  { href: "/elegant-blog", text: "Blog" },
  { href: "/elegant-contact", text: "Contact" },
];
export const elegantMultipageDark = [
  { href: "/elegant-multi-page-dark", text: "Home" },
  { href: "/elegant-about-dark", text: "About" },
  { href: "/elegant-services-dark", text: "Services" },
  { href: "/elegant-portfolio-dark", text: "Portfolio" },
  { href: "/elegant-blog-dark", text: "Blog" },
  { href: "/elegant-contact-dark", text: "Contact" },
];
export const elegantOnepage = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const corporateMultipage = [
  { href: "/corporate-multi-page", text: "Home" },
  { href: "/corporate-about", text: "About" },
  { href: "/corporate-services", text: "Services" },
  { href: "/corporate-portfolio", text: "Portfolio" },
  { href: "/corporate-blog", text: "Blog" },
  { href: "/corporate-contact", text: "Contact" },
];

export const corporateMultipageDark = [
  { href: "/corporate-multi-page-dark", text: "Home" },
  { href: "/corporate-about-dark", text: "About" },
  { href: "/corporate-services-dark", text: "Services" },
  { href: "/corporate-portfolio-dark", text: "Portfolio" },
  { href: "/corporate-blog-dark", text: "Blog" },
  { href: "/corporate-contact-dark", text: "Contact" },
];

export const corporateOnepage = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const brutalistMultipage = [
  { href: "/brutalist-multi-page", text: "Home", active: true },
  { href: "/brutalist-about", text: "About", active: false },
  { href: "/brutalist-services", text: "Services", active: false },
  { href: "/brutalist-portfolio", text: "Portfolio", active: false },
  { href: "/brutalist-blog", text: "Blog", active: false },
];
export const brutalistMultipageDark = [
  { href: "/brutalist-multi-page-dark", text: "Home", active: true },
  { href: "/brutalist-about-dark", text: "About", active: false },
  { href: "/brutalist-services-dark", text: "Services", active: false },
  { href: "/brutalist-portfolio-dark", text: "Portfolio", active: false },
  { href: "/brutalist-blog-dark", text: "Blog", active: false },
];
export const brutalistOnepage = [
  { href: "#home", text: "Home", className: "active", dataBtnAnimate: "y" },
  { href: "#about", text: "About", dataBtnAnimate: "y" },
  { href: "#services", text: "Services", dataBtnAnimate: "y" },
  { href: "#portfolio", text: "Portfolio", dataBtnAnimate: "y" },
  { href: "#blog", text: "Blog", dataBtnAnimate: "y" },
];
export const boldMultipage = [
  { href: "/bold-multi-page", text: "Home", active: false },
  { href: "/bold-about", text: "About", active: true },
  { href: "/bold-services", text: "Services", active: false },
  { href: "/bold-portfolio", text: "Portfolio", active: false },
  { href: "/bold-blog", text: "Blog", active: false },
  { href: "/bold-contact", text: "Contact", active: false },
];
export const boldMultipageDark = [
  { href: "/bold-multi-page-dark", text: "Home", active: false },
  { href: "/bold-about-dark", text: "About", active: true },
  { href: "/bold-services-dark", text: "Services", active: false },
  { href: "/bold-portfolio-dark", text: "Portfolio", active: false },
  { href: "/bold-blog-dark", text: "Blog", active: false },
  { href: "/bold-contact-dark", text: "Contact", active: false },
];

export const boldOnepage = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const mainDemoOnepage = [
  { href: "#home", text: "Home", className: "active" },
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const hometwopage = [
  { href: "home", text: "Home", className: "active" },
  // { href: "about", text: "About" },
  // { href: "services", text: "Services" },
  { href: "about", text: "About Us" },
  { href: "pricing", text: "Pricing" },
  { href: "contactus", text: "Contact Us" },
];

// Resources
export const Resources = [
  {
    title: "Resources",
    link: "#",
    subItems: [
      {
        title: "Blogs",
        link: "/blog/",
        ariaLabel: "Blogs"
      },
      {
        title: "Glossary",
        link: "/glossary/",
        ariaLabel: "Glossary"
      },
      {
        title: "Holiday 2025",
        link: "/holidays-list-2025/",
        ariaLabel: "Holidays 2025"
      },
      {
        title: "Top HRMS",
        link: "/top-hrms/",
        ariaLabel: "Top HRMS"
      },
      {
        title: "Interview Questions",
        link: "/interview-questions/",
        ariaLabel: "Interview Questions"
      },
      {
        title: "Web Stories",
        link: "/web-stories/",
        ariaLabel: "Web Stories"
      },
      {
        title: "Compare With",
        link: "/alternative/",
        ariaLabel: "Compare With"
      }
    ]
  }
];

// HRMS Solutions
export const HRMSSolutions = {
  title: "Solutions",
  links: [
    { text: "CA Firm", href: "/hrms-software/solutions/ca-firm/" },
    { text: "CS Firm", href: "/hrms-software/solutions/cs-firm/" },
    { text: "CPA Firm", href: "/hrms-software/solutions/cpa-firm/" },
    { text: "law firm", href: "/hrms-software/solutions/law-firm/" },
    { text: "BPO/KPO Firm", href: "/hrms-software/solutions/bpo-kpo/" },
    { text: "Real Estate", href: "/hrms-software/solutions/real-estate/" }
  ]
};

// Product
export const ProductsList = [
  {
    productname: "hrmssoftware",
    title: "GetBiz HRMS",
    link: "/hrms-software/",
    description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations.",
    image: "/assets/images/img/slides/hrms_slide.png",
    hoverText: "GetBiz HRMS"
  },
  {
    productname: "crmsoftware",
    title: "GetBiz CRM",
    link: "#",
    description: "Customer relationships with GetBiz Solutions' powerful CRM. Manage leads, automate tasks, and enhance customer satisfaction.",
    image: "/assets/images/img/slides/crm_slide.png",
    hoverText: "CRM"
  },
  {
    productname: "campaignsoftware",
    title: "GetBiz Campaigns",
    link: "#",
    description: "Create and manage email marketing campaigns, track performance, and automate follow-ups.",
    image: "/assets/images/img/slides/campaigns_slide.png",
    hoverText: "Campaigns"
  }
];

// Footer Company
export const Company = {
  title: "Company",
  links: [
    { text: "About", href: "/about/" },
    { text: "Careers", href: "#" },
    { text: "Customers", href: "/customers/" },
    { text: "Partner", href: "#" },
    { text: "Events", href: "#" },
    { text: "Blogs", href: "/blog/" },
    { text: "Testimonials", href: "/testimonials/" }
  ]
};

// Footer Support
export const Support = {
  title: "Support",
  links: [
    { text: "Help Center", href: "#" },
    { text: "Refund Policy", href: "#" },
    { text: "Free Trials", href: "#" },
    { text: "Community", href: "#" },
    { text: "Contact Us", href: "#" },
    { text: "GetBiz Solutions Training", href: "#" }
  ]
};

// Home Header
export const HomeHeaderData = {
  "brand": {
    "logo": "/assets/images/img/logo/getbiz_main_logo.webp",
    "website_name": "GetBiz Solutions",
    "homepage_link": "",
  },
  "products": {
    "title": "Products",
    "items": ProductsList
  },
  "resources": Resources,
  "solutions": {
    "title": "Solutions",
    "items": [
      {
        "title": "IT Solutions",
        "link": "/solutions/it-solutions/"
      },
      {
        "title": "Marketing Automation",
        "link": "/solutions/marketing-automation/"
      },
      {
        "title": "Customer Service Solutions",
        "link": "/solutions/customer-service-solutions/"
      },
      {
        "title": "Customer Relationship Management",
        "link": "/solutions/customer-relationship-management/"
      },
      {
        "title": "Enterprise Service Management",
        "link": "/solutions/enterprise-service-management/"
      },
      {
        "title": "Sales Automation",
        "link": "/solutions/sales-automation/"
      }

    ]
  },
  "otherlinks": [
    { href: "/about/", text: "About Us" },
    { href: "/pricing/", text: "Pricing" },
    { href: "/contactus/", text: "Contact Us" },
  ],
  "cta": {
    cta_name: "Book Demo",
    cta_link: "/book-demo/",
    cta_class: "btn btn-mod btn-border-grad btn-small btn-round",
  }
}

// Home Footer
export const FooterData = {
  brand: {
    logo: "/assets/images/img/logo/getbiz_main_logo.webp",
    name: "GetBiz Solutions",
    link: "/",
    description: "GetBiz Solutions provides digital tools for businesses, such as IT solutions, CRM, and HRMS. We help companies streamline operations and boost growth.",
    email: "sales@getbiz.solutions",
    highlightProducts: [
      {
        title: "",
        link: "",
        image: ""
      },
      {
        title: "CRM Software",
        link: "#",
        image: "/assets/images/img/product/crm-software/crm_feature_process-management.webp"
      }
    ]
  },
  badges: [
    { src: "", alt: "Google Rating", height: 50 },
    { src: "/assets/images/img/icon/up1.png", alt: "Upwork Rating", height: 50 },
    { src: "/assets/images/img/icon/c1.png", alt: "Clutch Rating", height: 35 }
  ],
  sections: [
    {
      title: "Compare with",
      links: [{ text: "vs Keka", href: "/alternative/keka-alternative/" }]
    },
    {
      title: "Product",
      links: ProductsList.map(product => ({
        text: product.title,
        href: product.link,
        target: "_blank"
      }))
    },
    Company,
    Support
  ]
};

export const HRMSFooterData = {
  brand: {
    logo: "/assets/images/img/logo/gb_hrms_new.webp",
    name: "GetBiz Solutions",
    link: "/",
    description: "GetBiz Solutions provides digital tools for businesses, such as IT solutions, CRM, and HRMS. We help companies streamline operations and boost growth.",
    email: "sales@getbiz.solutions",
    highlightProducts: [
      {
        title: "",
        link: "",
        image: ""
      },
      {
        title: "CRM Software",
        link: "#",
        image: "/assets/images/img/product/crm-software/crm_feature_process-management.webp"
      }
    ]
  },
  badges: [
    { src: "", alt: "Google Rating", height: 50 },
    { src: "/assets/images/img/icon/up1.png", alt: "Upwork Rating", height: 50 },
    { src: "/assets/images/img/icon/c1.png", alt: "Clutch Rating", height: 35 }
  ],
  sections: [
    {
      title: "Compare with",
      links: [{ text: "vs Keka", href: "/alternative/keka-alternative/" }]
    },
    {
      "title": "Feature",
      "links": [
        {
          "text": "Leave Policy Allocation",
          "href": "/hrms-software/leave-management-system/leave-policy-allocation/",
          "target": "_blank"
        },
        {
          "text": "Leave Balance",
          "href": "/hrms-software/leave-management-system/leave-balance/",
          "target": "_blank"
        },
        {
          "text": "Leave Accrual Details",
          "href": "/hrms-software/leave-management-system/leave-accrual-details/",
          "target": "_blank"
        },
        {
          "text": "Leave Approval",
          "href": "/hrms-software/leave-management-system/leave-approval/",
          "target": "_blank"
        },
        {
          "text": "Leave History",
          "href": "/hrms-software/leave-management-system/leave-history/",
          "target": "_blank"
        },
        {
          "text": "Leave Types",
          "href": "/hrms-software/leave-management-system/leave-types/",
          "target": "_blank"
        }
      ]
    }
    ,
    Company,
    Support
  ]
};

export const CRMFooterData = {
  brand: {
    logo: "/assets/images/img/logo/getbiz_crm.webp",
    name: "GetBiz Solutions",
    link: "/",
    description: "GetBiz Solutions provides digital tools for businesses, such as IT solutions, CRM, and HRMS. We help companies streamline operations and boost growth.",
    email: "sales@getbiz.solutions",
    highlightProducts: [
      {
        title: "",
        link: "",
        image: ""
      },
      {
        title: "CRM Software",
        link: "#",
        image: "/assets/images/img/product/crm-software/crm_feature_process-management.webp"
      }
    ]
  },
  badges: [
    { src: "", alt: "Google Rating", height: 50 },
    { src: "/assets/images/img/icon/up1.png", alt: "Upwork Rating", height: 50 },
    { src: "/assets/images/img/icon/c1.png", alt: "Clutch Rating", height: 35 }
  ],
  sections: [
    {
      title: "Compare with",
      links: [{ text: "vs Keka", href: "/alternative/keka-alternative/" }]
    },
    {
      "title": "Feature",
      "links": [
        {
          "text": "Lead Management",
          "href": "/crm-software/salesforce-automation/lead-management/",
          "target": ""
        },
        {
          "text": "Approval Process",
          "href": "/crm-software/process-management/approval-process/",
          "target": ""
        },
        {
          "text": "Multi-page Layout",
          "href": "/crm-software/process-management/multi-page-layout/",
          "target": ""
        },
        {
          "text": "Live Chat",
          "href": "/crm-software/omni-channels/live-chat/",
          "target": ""
        },
        {
          "text": "Reports",
          "href": "/crm-software/crm-analytics/reports/",
          "target": ""
        },
        {
          "text": "KPI Dashboards",
          "href": "/crm-software/crm-analytics/kpis/",
          "target": ""
        }
      ]
    }
    ,
    Company,
    Support
  ]
};

// CRM Product Header
export const CRMProduct = [
  {
    productName: "CRM Solution",
    productLogo: "/assets/images/img/logo/getbiz_crm.webp",
    productLink: "#",
    productFeatures: {
      'salesforce-automation': {
        title: "Salesforce Automation",
        link: "/crm-software/salesforce-automation/",
        subItems: [
          {
            title: "Lead Management",
            link: '/crm-software/salesforce-automation/lead-management/',
          },
          {
            title: "Deal Management",
            link: '/crm-software/salesforce-automation/deal-management/',
          },
          {
            title: "Contact Management",
            link: '/crm-software/salesforce-automation/contact-management/',
          },
          {
            title: "Account Management",
            link: '/crm-software/salesforce-automation/account-management/',
          },
          {
            title: "Workflow Management",
            link: '/crm-software/salesforce-automation/workflow-management/',
          },
          {
            title: "Cadences",
            link: '/crm-software/salesforce-automation/cadences/',
          }
        ]
      },
      'process-management': {
        title: "Process Management",
        link: "/crm-software/process-management/",
        subItems: [
          {
            title: "Blueprint",
            link: '/crm-software/process-management/sales-blueprint/',
          },
          {
            title: "Lead Scoring",
            link: '/crm-software/process-management/lead-scoring/',
          },
          {
            title: "Approval Process",
            link: '/crm-software/process-management/approval-process/',
          },
          {
            title: "Assignment Rule",
            link: '/crm-software/process-management/assignment-rule/',
          },
          {
            title: "Review Process",
            link: '/crm-software/process-management/review-process/',
          },
          {
            title: "Validation Rule",
            link: '/crm-software/process-management/validation-rule/',
          },
          {
            title: "Multi-page Layout",
            link: '/crm-software/process-management/multi-page-layout/',
          },
        ]
      },
      'omni-channels': {
        title: "Omni Channels",
        link: "/crm-software/omni-channels/",
        subItems: [
          {
            title: "Email",
            link: '/crm-software/omni-channels/email/',
          },
          {
            title: "Telephony",
            link: '/crm-software/omni-channels/telephony/',
          },
          {
            title: "Social Media",
            link: '/crm-software/omni-channels/social-media/',
          },
          {
            title: "SMS",
            link: '/crm-software/omni-channels/sms/',
          },
          {
            title: "Whatsapp",
            link: '/crm-software/omni-channels/whatsapp/',
          },
          {
            title: "Live Chat",
            link: '/crm-software/omni-channels/live-chat/',
          },
          {
            title: "Webforms",
            link: '/crm-software/omni-channels/webforms/',
          },
        ]
      },
      'crm-analytics': {
        title: "Analytics",
        link: "/crm-software/crm-analytics/",
        subItems: [
          {
            title: "Reports",
            link: '/crm-software/crm-analytics/reports/',
          },
          {
            title: "Charts",
            link: '/crm-software/crm-analytics/charts/',
          },
          {
            title: "Cohorts",
            link: '/crm-software/crm-analytics/cohorts/',
          },
          {
            title: "KPIs",
            link: '/crm-software/crm-analytics/kpis/',
          },
          {
            title: "Funnels",
            link: '/crm-software/crm-analytics/funnels/',
          },
        ]
      },
      'sales-performance': {
        title: "Sales Performance",
        link: "/crm-software/sales-performance/",
        subItems: [
          {
            title: "Forecasting",
            link: '/crm-software/sales-performance/forecasting/',
          },
          {
            title: "Multiple Currencies",
            link: '/crm-software/sales-performance/multiple-currencies/',
          },
          {
            title: "Analytics",
            link: '/crm-software/sales-performance/analytics/',
          },
          {
            title: "Visitor Tracking",
            link: '/crm-software/sales-performance/visitor-tracking/',
          },
        ]
      },
      'sales-enablement': {
        title: "Sales Enablement",
        link: "/crm-software/sales-enablement/",
        subItems: [
          {
            title: "Finance",
            link: '/crm-software/sales-enablement/finance/',
          },
          {
            title: "Configure, Price, Quote (CPQ)",
            link: '/crm-software/sales-enablement/configure-price-quote/',
          },
          {
            title: "Documents Library",
            link: '/crm-software/sales-enablement/documents-library/',
          },
          {
            title: "Calendar",
            link: '/crm-software/sales-enablement/calendar/',
          },
          {
            title: "SalesInbox",
            link: '/crm-software/sales-enablement/salesinbox/',
          },
          {
            title: "Zoom Meeting Integration",
            link: '/crm-software/sales-enablement/zoom-meeting-integration/',
          },
          {
            title: "Alert and Notification",
            link: '/crm-software/sales-enablement/alert-and-notification/',
          },
        ]
      },
    },
    productTheme: "only text",
    productMainClass: "light-mode-logo rounded-md",
    cta: {
      ctaButtonName: "Get in touch",
      ctaButtonLink: "/contactus/",
      ctaButtonClass: "btn btn-mod btn-color-light btn-border-white-light btn-small btn-circle"
    },
    resources: Resources,
  }
];

// HRMS Product Header
export const HRMSProduct = [
  {
    productName: "HRMS Software",
    productLogo: "/assets/images/img/logo/gb_hrms_new.webp",
    productLink: "/hrms-software/",
    productFeatures: {
      'Leave': {
        title: "Leave Management",
        description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
        image: "/assets/images/img/it_solutions_itsm.png",
        link: "/hrms-software/leave-management-system/",
        subItems: [
          {
            title: "Leave Requests",
            link: '/hrms-software/leave-management-system/leave-requests/',
          },
          {
            title: "Leave Approval",
            link: '/hrms-software/leave-management-system/leave-approval/',
          },
          {
            title: "Leave History",
            link: '/hrms-software/leave-management-system/leave-history/',
          },
          {
            title: "Leave Dashboard",
            link: '/hrms-software/leave-management-system/leave-dashboard/',
          },
          {
            title: "Leave Reports",
            link: '/hrms-software/leave-management-system/leave-reports/',
          },
          {
            title: "Leave Balance",
            link: '/hrms-software/leave-management-system/leave-balance/',
          },
          {
            title: "Leave Types",
            link: '/hrms-software/leave-management-system/leave-types/',
          },
          {
            title: "Leave Policy Allocation",
            link: '/hrms-software/leave-management-system/leave-policy-allocation/',
          },
          {
            title: "Leave Accrual Details",
            link: '/hrms-software/leave-management-system/leave-accrual-details/',
          },
        ]
      },
      'Attendance': {
        title: "Attendance Management",
        description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
        image: "/assets/images/img/it_solutions_itsm.webp",
        link: "/hrms-software/attendance-management-system/",
        subItems: [
          {
            title: "Real Time Attendance Tracking",
            link: '/hrms-software/attendance-management-system/real-time-attendance-tracking/',
          },
          {
            title: "Absence Management",
            link: '/hrms-software/attendance-management-system/absence-management/',
          },
          {
            title: "Overtime Monitoring",
            link: '/hrms-software/attendance-management-system/overtime-monitoring/',
          },
          {
            title: "Shift Management",
            link: '/hrms-software/attendance-management-system/shift-management/',
          },
          {
            title: "Geofencing Attendance",
            link: '/hrms-software/attendance-management-system/geofencing-attendance/',
          },
          {
            title: "Comprehensive Reporting",
            link: '/hrms-software/attendance-management-system/comprehensive-reporting/',
          },
          {
            title: "Attendance Dashboard",
            link: '/hrms-software/attendance-management-system/attendance-dashboard/',
          }
        ]
      },
      'Employee': {
        title: "Employee Management",
        description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
        image: "/assets/images/img/it_solutions_itsm.webp",
        link: "/hrms-software/employee-management-system/",
        subItems: [
          {
            title: "Employee Directory",
            link: '/hrms-software/employee-management-system/employee-directory/',
          },
          {
            title: "Attendance Tracking",
            link: '/hrms-software/employee-management-system/attendance-tracking/',
          },
          {
            title: "Performance Review",
            link: '/hrms-software/employee-management-system/performance-review/',
          },
          {
            title: "Leave Management",
            link: '/hrms-software/employee-management-system/leave-management/',
          },
          {
            title: "Employee Shift Management",
            link: '/hrms-software/employee-management-system/employee-shift-management/',
          },
          {
            title: "Payroll Integration",
            link: '/hrms-software/employee-management-system/payroll-integration/',
          }
        ]
      },
      'payroll': {
        title: "Payroll Management",
        description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
        image: "/assets/images/img/it_solutions_itsm.webp",
        link: "/hrms-software/payroll-management-system/",
        subItems: [
          {
            title: "Automated Salary Calculation",
            link: '/hrms-software/payroll-management-system/automated-salary-calculation/',
          },
          {
            title: "Tax and Compliance Management",
            link: '/hrms-software/payroll-management-system/tax-and-compliance-management/',
          },
          {
            title: "Custom Deductions",
            link: '/hrms-software/payroll-management-system/custom-deductions/',
          },
          {
            title: "Overtime and Leave Calculations",
            link: '/hrms-software/payroll-management-system/overtime-leave-calculations/',
          },
          {
            title: "Payslip Generation",
            link: '/hrms-software/payroll-management-system/payslip-generation/',
          },
          {
            title: "Integration with Accounting",
            link: '/hrms-software/payroll-management-system/integration-with-accounting/',
          }
        ]
      },
      'recruitment': {
        title: "Recruitment Management",
        description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
        image: "/assets/images/img/it_solutions_itsm.webp",
        link: "/hrms-software/recruitment-management-systems/",
        subItems: [
          {
            title: "Multi-Platform Job Posting",
            link: '/hrms-software/recruitment-management-systems/multi-platform-job-posting/',
          },
          {
            title: "Resume Parsing",
            link: '/hrms-software/recruitment-management-systems/resume-parsing/',
          },
          {
            title: "Candidate Communication",
            link: '/hrms-software/recruitment-management-systems/candidate-communication/',
          },
          {
            title: "Interview Management",
            link: '/hrms-software/recruitment-management-systems/interview-management/',
          },
          {
            title: "Reporting and Analytics",
            link: '/hrms-software/recruitment-management-systems/reporting-and-analytics/',
          }
        ]
      },
    },
    productTheme: "",
    productMainClass: "light-mode-logo rounded-md",
    cta: {
      ctaButtonName: "Get in touch",
      ctaButtonLink: "/contactus/",
      ctaButtonClass: "btn-round btn btn-mod btn-border-white-light btn-small btn-circle"
    },
    hrmssolutions: HRMSSolutions,
    ProductsList: ProductsList
  }
];

// HRMS Menu
export const menuItems = [

  {
    title: "Home",
    subMenu: [
      {
        title: "Multi Page",
        links: [
          { href: "/main-multi-page", text: "Main Demo" },
          { href: "/main-multi-page-typed-text", text: "Typed Text" },
          { href: "/main-multi-page-image-parallax", text: "Image Parallax" },
          {
            href: "/main-multi-page-slider-fullscreen",
            text: "Slider Fullscreen",
          },
          {
            href: "/main-multi-page-slider-background",
            text: "Slider Background",
          },
          { href: "/main-multi-page-bg-video", text: "BG Video HTML5" },
          {
            href: "/main-multi-page-bg-video-youtube",
            text: "BG Video Youtube",
          },
          { href: "/main-multi-page-dark", text: "Dark Version" },
        ],
      },
      {
        title: "One Page",
        links: [
          { href: "/main-one-page", text: "Main Demo" },
          { href: "/main-one-page-typed-text", text: "Typed Text" },
          { href: "/main-one-page-image-parallax", text: "Image Parallax" },
          {
            href: "/main-one-page-slider-fullscreen",
            text: "Slider Fullscreen",
          },
          {
            href: "/main-one-page-slider-background",
            text: "Slider Background",
          },
          { href: "/main-one-page-bg-video", text: "BG Video HTML5" },
          { href: "/main-one-page-bg-video-youtube", text: "BG Video Youtube" },
          { href: "/main-one-page-dark", text: "Dark Version" },
        ],
      },
    ],
  },
  {
    title: "Pages",
    subMenu: [
      {
        title: "Group 1",
        links: [
          { href: "/main-pages-about-1", text: "About Us 1" },
          { href: "/main-pages-about-2", text: "About Us 2" },
          { href: "/main-pages-about-3", text: "About Us 3" },
          { href: "/main-pages-services-1", text: "Services 1" },
          { href: "/main-pages-services-2", text: "Services 2" },
          { href: "/main-pages-services-3", text: "Services 3" },
          { href: "/main-pages-clients", text: "Clients" },
        ],
      },
      {
        title: "Group 2",
        links: [
          { href: "/main-pages-team", text: "Team" },
          { href: "/main-pages-faq-1", text: "FAQ 1" },
          { href: "/main-pages-faq-2", text: "FAQ 2" },
          { href: "/main-pages-pricing-1", text: "Pricing 1" },
          { href: "/main-pages-pricing-2", text: "Pricing 2" },
          { href: "/main-pages-contact-1", text: "Contact 1" },
          { href: "/main-pages-contact-2", text: "Contact 2" },
        ],
      },
      {
        title: "Group 3",
        links: [
          { href: "/main-pages-gallery-1col", text: "Gallery Col 1" },
          { href: "/main-pages-gallery-2col", text: "Gallery Col 2" },
          { href: "/main-pages-gallery-3col", text: "Gallery Col 3" },
          { href: "/main-pages-gallery-4col", text: "Gallery Col 4" },
          { href: "/main-pages-account", text: "Login / Register" },
          {
            href: "/main-pages-under-construction",
            text: "Under Construction",
          },
          { href: "/main-pages-404", text: "Error 404" },
        ],
      },
    ],
  },
  {
    title: "Elements",
    subMenu: [
      {
        links: [
          {
            href: "/main-elements-accordions",
            icon: "mi-circle-add",
            text: "Accordions",
          },
          {
            href: "/main-elements-alert-messages",
            icon: "mi-circle-information",
            text: "Alert Messages",
          },
          {
            href: "/main-elements-animation",
            icon: "mi-play",
            text: "Animation",
          },
          {
            href: "/main-elements-bars",
            icon: "mi-bar-chart",
            text: "Bars (Progress)",
          },
          { href: "/main-elements-buttons", icon: "mi-link", text: "Buttons" },
          {
            href: "/main-elements-cookie-banner",
            icon: "mi-flag",
            text: "Cookie Banner",
          },
          {
            href: "/main-elements-features",
            icon: "mi-grid",
            text: "Feature Boxes",
          },
          {
            href: "/main-elements-forms",
            icon: "mi-three-rows",
            text: "Form Fields",
          },
          { href: "/main-elements-grid", icon: "mi-layout", text: "Grid" },
          {
            href: "/main-elements-icons-brands",
            icon: "mi-circle",
            text: "Icons Brands",
          },
          {
            href: "/main-elements-icons-iconmonstr",
            icon: "mi-favorite",
            text: "Icons Iconmonstr",
          },
          {
            href: "/main-elements-icons-Ionicons",
            icon: "mi-heart",
            text: "Icons Ionicons",
          },
          {
            href: "/main-elements-icons-monoicons",
            icon: "mi-sun",
            text: "Icons Monoicons",
          },
        ],
      },
      {
        links: [
          {
            href: "/main-elements-images-lazyload",
            icon: "mi-image",
            text: "Images Lazyload",
          },
          {
            href: "/main-elements-lightbox",
            icon: "mi-window",
            text: "Lightbox",
          },
          {
            href: "/main-elements-sliders",
            icon: "mi-circle-arrow-right",
            text: "Sliders",
          },
          {
            href: "/main-elements-sliders-lazyload",
            icon: "mi-circle-arrow-right",
            text: "Sliders Lazyload",
          },
          { href: "/main-elements-tabs", icon: "mi-two-columns", text: "Tabs" },
          {
            href: "/main-elements-tooltips",
            icon: "mi-message",
            text: "Tooltips",
          },
          {
            href: "/main-elements-typography",
            icon: "mi-text",
            text: "Typography",
          },
          {
            href: "/main-elements-video-sound",
            icon: "mi-webcam",
            text: "Video / Sound",
          },
          {
            href: "/main-elements-header-dark-light",
            icon: "mi-book",
            text: "Header Dark",
          },
          {
            href: "/main-elements-header-dark-transparent",
            icon: "mi-book",
            text: "Header Dark Transp",
          },
          {
            href: "/main-elements-header-white",
            icon: "mi-book",
            text: "Header White",
          },
          {
            href: "/main-elements-header-white-transparent",
            icon: "mi-book",
            text: "Header White Transp",
          },
          {
            href: "/main-elements-header-white-after-scroll",
            icon: "mi-book",
            text: "Header Scroll-White",
          },
        ],
      },
    ],
  },
  {
    title: "Portfolio",
    subItems: [
      {
        title: "Boxed",
        links: [
          { href: "/main-portfolio-boxed-2col", label: "2 Columns" },
          { href: "/main-portfolio-boxed-3col", label: "3 Columns" },
          { href: "/main-portfolio-boxed-4col", label: "4 Columns" },
        ],
      },
      {
        title: "Wide",
        links: [
          { href: "/main-portfolio-wide-2col", label: "2 Columns" },
          { href: "/main-portfolio-wide-3col", label: "3 Columns" },
          { href: "/main-portfolio-wide-4col", label: "4 Columns" },
        ],
      },
      {
        title: "Masonry",
        links: [
          { href: "/main-portfolio-masonry-2col", label: "2 Columns" },
          { href: "/main-portfolio-masonry-3col", label: "3 Columns" },
          { href: "/main-portfolio-masonry-4col", label: "4 Columns" },
        ],
      },
      {
        title: "Single",
        links: [
          { href: "/main-portfolio-single-1/1", label: "Single 1" },
          { href: "/main-portfolio-single-2/1", label: "Single 2" },
          { href: "/main-portfolio-single-3/1", label: "Single 3" },
        ],
      },
    ],
  },
  {
    title: "Blog",
    subItems: [
      {
        title: "Classic",
        links: [
          { href: "/main-blog-classic-sidebar-left", label: "Sidebar Left" },
          { href: "/main-blog-classic-sidebar-right", label: "Sidebar Right" },
          { href: "/main-blog-classic-fullwidth", label: "Fullwidth" },
        ],
      },
      {
        title: "Columns",
        links: [
          { href: "/main-blog-columns-2col", label: "2 Columns" },
          { href: "/main-blog-columns-3col", label: "3 Columns" },
        ],
      },
      {
        title: "Single",
        links: [
          { href: "/main-blog-single-sidebar-left/1", label: "Sidebar Left" },
          { href: "/main-blog-single-sidebar-right/1", label: "Sidebar Right" },
          { href: "/main-blog-single-fullwidth/1", label: "Fullwidth" },
        ],
      },
    ],
  },
  {
    title: "My Page",
    subMenu: [
      {
        title: "All Pages",
        links: [
          { href: "/about/", text: "About Us", icon: "mi-circle-information" },
          { href: "/pricing/", text: "Pricing" },
          { href: "/careers/", text: "Career" },
          { href: "/testimonials/", text: "Testimonial" },
          { href: "/contactus/", text: "Contact" },
          { href: "/customers/", text: "Customer" },
          { href: "/blog/", text: "Blogs" },
          { href: "/blog/blogread", text: "Blog Read" },
          { href: "/glossary/", text: "Glossary" },
          { href: "/glossary/glossaryread", text: "Glossary Read" },
          { href: "/book-demo/", text: "Book Demo" },
          { href: "/product-tours/", text: "Product Tours" },
        ],
      },
      {
        title: "HRMS",
        links: [
          { href: "/hrms-software/", text: "HRMS" },
          { href: "/hrms-software/leave-management-system", text: "Leave Management System" },
          { href: "/hrms-software/leave-management-system/leave-policy-allocation", text: "Leave Policy Allocation" },
          { href: "/hrms-software/leave-management-system/leave-balance", text: "Leave Balance" },
          { href: "/hrms-software/leave-management-system/leave-accrual-details", text: "Leave Accrual Details" },
          { href: "/hrms-software/leave-management-system/leave-approval/", text: "Easy Approval/Decline" },
          { href: "/hrms-software/leave-management-system/leave-history/", text: "Leave History" },
          { href: "/hrms-software/leave-management-system/leave-types/", text: "Leave Types" },
        ],
      },
      {
        title: "Solutions",
        links: [
          { href: "/solutions/it-solutions/", text: "IT Solutions" },
          { href: "/solutions/marketing-automation/", text: "Marketing Automation" },
          { href: "/solutions/customer-service-solutions/", text: "Customer Service Solutions" },
          { href: "/solutions/customer-relationship-management/", text: "Customer Relationship Management" },
          { href: "/solutions/enterprise-service-management/", text: "Enterprise Service Management" },
          { href: "/solutions/sales-automation/", text: "Sales Automation" },
          { href: "solutions/ca-firm/", text: "CA Firm" },
          { href: "/solutions/cs-firm/", text: "CS Firm" },
          { href: "/solutions/cpa-firm/", text: "CPA Firm" },
          { href: "/solutions/law-firm/", text: "LAW Firm" },
          { href: "/solutions/bpo-kpo/", text: "BPO/KPO" },
          { href: "/solutions/real-estate/", text: "Real Estate" },
        ],
      },
      {
        title: "All Pages",
        links: [
          { href: "/about/", text: "About Us", icon: "mi-circle-information" },
          { href: "/pricing/", text: "Pricing" },
          { href: "/careers/", text: "Career" },
          { href: "/testimonials/", text: "Testimonial" },
          { href: "/contactus/", text: "Contact" },
          { href: "/customers/", text: "Customer" },
          { href: "/blog/", text: "Blogs" },
          { href: "/blog/blogread/", text: "Blog Read" },
          { href: "/glossary/", text: "Glossary" },
          { href: "/glossary/glossaryread/", text: "Glossary Read" },
          { href: "/book-demo/", text: "Book Demo" },
          { href: "/product-tours/", text: "Product Tours" },
        ],
      },
    ],
  },
];

export const HRMSFeatures = {
  'Leave': {
    title: "Leave Management",
    description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
    image: "/assets/images/img/it_solutions_itsm.png",
    link: "/solutions",
    subItems: [
      {
        title: "Leave Requests",
        link: '/hrms-software/leave-management-system/leave-requests/',
      },
      {
        title: "Leave Approval",
        link: '/hrms-software/leave-management-system/leave-approval/',
      },
      {
        title: "Leave History",
        link: '/hrms-software/leave-management-system/leave-history',
      },
      {
        title: "Leave Dashboard",
        link: '/hrms-software/leave-management-system/leave-dashboard/',
      },
      {
        title: "Leave Reports",
        link: '/hrms-software/leave-management-system/leave-reports/',
      },
      {
        title: "Leave Balance",
        link: '/hrms-software/leave-management-system/leave-balance/',
      },
      {
        title: "Leave Types",
        link: '/hrms-software/leave-management-system/leave-types/',
      },
      {
        title: "Leave Policy Allocation",
        link: '/hrms-software/leave-management-system/leave-policy-allocation/',
      },
      {
        title: "Leave Accrual Details",
        link: '/hrms-software/leave-management-system/leave-accrual-details/',
      },
    ]
  },
  'Attendance': {
    title: "Attendance Management",
    description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
    image: "/assets/images/img/it_solutions_itsm.webp",
    link: "/hrms-software/attendance-management-system/",
    subItems: [
      {
        title: "Real Time Attendance Tracking",
        link: '/hrms-software/attendance-management-system/real-time-attendance-tracking/',
      },
      {
        title: "Absence Management",
        link: '/hrms-software/attendance-management-system/absence-management/',
      },
      {
        title: "Overtime Monitoring",
        link: '/hrms-software/attendance-management-system/overtime-monitoring/',
      },
      {
        title: "Shift Management",
        link: '/hrms-software/attendance-management-system/shift-management/',
      },
      {
        title: "Geofencing Attendance",
        link: '/hrms-software/attendance-management-system/geofencing-attendance/',
      },
      {
        title: "Comprehensive Reporting",
        link: '/hrms-software/attendance-management-system/comprehensive-reporting/',
      },
      {
        title: "Attendance Dashboard",
        link: '/hrms-software/attendance-management-system/attendance-dashboard/',
      }
    ]
  },
  'Employee': {
    title: "Employee Management",
    description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
    image: "/assets/images/img/it_solutions_itsm.webp",
    link: "/hrms-software/employee-management-system/",
    subItems: [
      {
        title: "Employee Directory",
        link: '/hrms-software/employee-management-system/employee-directory/',
      },
      {
        title: "Attendance Tracking",
        link: '/hrms-software/employee-management-system/attendance-tracking/',
      },
      {
        title: "Performance Review",
        link: '/hrms-software/employee-management-system/performance-review/',
      },
      {
        title: "Leave Management",
        link: '/hrms-software/employee-management-system/leave-management/',
      },
      {
        title: "Employee Shift Management",
        link: '/hrms-software/employee-management-system/employee-shift-management/',
      },
      {
        title: "Payroll Integration",
        link: '/hrms-software/employee-management-system/payroll-integration/',
      }
    ]
  },
  'payroll': {
    title: "Employee Management",
    description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
    image: "/assets/images/img/it_solutions_itsm.webp",
    link: "/hrms-software/employee-management-system/",
    subItems: [
      {
        title: "Automated Salary Calculation",
        link: '/hrms-software/payroll-management-system/automated-salary-calculation/',
      },
      {
        title: "Tax and Compliance Management",
        link: '/hrms-software/payroll-management-system/tax-and-compliance-management/',
      },
      {
        title: "Custom Deductions",
        link: '/hrms-software/payroll-management-system/custom-deductions/',
      },
      {
        title: "Overtime and Leave Calculations",
        link: '/hrms-software/payroll-management-system/overtime-leave-calculations/',
      },
      {
        title: "Payslip Generation",
        link: '/hrms-software/payroll-management-system/payslip-generation/',
      },
      {
        title: "Integration with Accounting",
        link: '/hrms-software/payroll-management-system/integration-with-accounting/',
      }
    ]
  },
  'recruitment': {
    title: "Employee Management",
    description: "GetBiz Solutions offers a powerful suite of products, including HRMS and CRM, to streamline your business operations. Enhance productivity and drive growth with our comprehensive tools.",
    image: "/assets/images/img/it_solutions_itsm.webp",
    link: "/hrms-software/employee-management-system/",
    subItems: [
      {
        title: "Multi-Platform Job Posting",
        link: '/hrms-software/recruitment-management-systems/multi-platform-job-posting/',
      },
      {
        title: "Resume Parsing",
        link: '/hrms-software/recruitment-management-systems/resume-parsing/',
      },
      {
        title: "Candidate Communication",
        link: '/hrms-software/recruitment-management-systems/candidate-communication/',
      },
      {
        title: "Interview Management",
        link: '/hrms-software/recruitment-management-systems/interview-management/',
      },
      {
        title: "Reporting and Analytics",
        link: '/hrms-software/recruitment-management-systems/reporting-and-analytics/',
      }
    ]
  },
};

export const CRMFeatures = {
  'salesforce-automation': {
    title: "Salesforce Automation",
    subItems: [
      {
        title: "Lead Management",
        link: '/crm-software/salesforce-automation/lead-management/',
      },
      {
        title: "Deal Management",
        link: '/crm-software/salesforce-automation/deal-management/',
      },
      {
        title: "Contact Management",
        link: '/crm-software/salesforce-automation/contact-management/',
      },
      {
        title: "Account Management",
        link: '/crm-software/salesforce-automation/account-management/',
      },
      {
        title: "Workflow Management",
        link: '/crm-software/salesforce-automation/workflow-management/',
      },
      {
        title: "Cadences",
        link: '/crm-software/salesforce-automation/cadences/',
      }
    ]
  },
  'process-management': {
    title: "Process Management",
    subItems: [
      {
        title: "Blueprint",
        link: '/crm-software/process-management/sales-blueprint/',
      },
      {
        title: "Lead Scoring",
        link: '/crm-software/process-management/lead-scoring/',
      },
      {
        title: "Approval Process",
        link: '/crm-software/process-management/approval-process/',
      },
      {
        title: "Assignment Rule",
        link: '/crm-software/process-management/assignment-rule/',
      },
      {
        title: "Review Process",
        link: '/crm-software/process-management/review-process/',
      },
      {
        title: "Validation Rule",
        link: '/crm-software/process-management/validation-rule/',
      },
      {
        title: "Multi-page Layout",
        link: '/crm-software/process-management/multi-page-layout/',
      },
    ]
  },
  'omni-channels': {
    title: "Omni Channels",
    subItems: [
      {
        title: "Email",
        link: '/crm-software/omni-channels/email/',
      },
      {
        title: "Telephony",
        link: '/crm-software/omni-channels/telephony/',
      },
      {
        title: "Social Media",
        link: '/crm-software/omni-channels/social-media/',
      },
      {
        title: "SMS",
        link: '/crm-software/omni-channels/sms/',
      },
      {
        title: "Whatsapp",
        link: '/crm-software/omni-channels/whatsapp/',
      },
      {
        title: "Live Chat",
        link: '/crm-software/omni-channels/live-chat/',
      },
      {
        title: "Webforms",
        link: '/crm-software/omni-channels/webforms/',
      },
    ]
  },
  'crm-analytics': {
    title: "Analytics",
    subItems: [
      {
        title: "Reports",
        link: '/crm-software/crm-analytics/reports/',
      },
      {
        title: "Charts",
        link: '/crm-software/crm-analytics/charts/',
      },
      {
        title: "Cohorts",
        link: '/crm-software/crm-analytics/cohorts/',
      },
      {
        title: "KPIs",
        link: '/crm-software/crm-analytics/kpis/',
      },
      {
        title: "Funnels",
        link: '/crm-software/crm-analytics/funnels/',
      },
    ]
  },
  'sales-performance': {
    title: "Sales Performance",
    subItems: [
      {
        title: "Forecasting",
        link: '/crm-software/sales-performance/forecasting/',
      },
      {
        title: "Multiple Currencies",
        link: '/crm-software/sales-performance/multiple-currencies/',
      },
      {
        title: "Analytics",
        link: '/crm-software/sales-performance/analytics/',
      },
      {
        title: "Visitor Tracking",
        link: '/crm-software/sales-performance/visitor-tracking/',
      },
    ]
  },
  'sales-enablement': {
    title: "Sales Enablement",
    subItems: [
      {
        title: "Finance",
        link: '/crm-software/sales-enablement/finance/',
      },
      {
        title: "Configure, Price, Quote (CPQ)",
        link: '/crm-software/sales-enablement/configure-price-quote/',
      },
      {
        title: "Documents Library",
        link: '/crm-software/sales-enablement/documents-library/',
      },
      {
        title: "Calendar",
        link: '/crm-software/sales-enablement/calendar/',
      },
      {
        title: "SalesInbox",
        link: '/crm-software/sales-enablement/salesinbox/',
      },
      {
        title: "Zoom Meeting Integration",
        link: '/crm-software/sales-enablement/zoom-meeting-integration/',
      },
      {
        title: "Alert and Notification",
        link: '/crm-software/sales-enablement/alert-and-notification/',
      },
    ]
  },
};



export const menuItemsDark = [
  {
    title: "Home",
    subMenu: [
      {
        title: "Multi Page",
        links: [
          { href: "/main-multi-page-dark", text: "Main Demo" },
          { href: "/main-multi-page-typed-text-dark", text: "Typed Text" },
          {
            href: "/main-multi-page-image-parallax-dark",
            text: "Image Parallax",
          },
          {
            href: "/main-multi-page-slider-fullscreen-dark",
            text: "Slider Fullscreen",
          },
          {
            href: "/main-multi-page-slider-background-dark",
            text: "Slider Background",
          },
          { href: "/main-multi-page-bg-video-dark", text: "BG Video HTML5" },
          {
            href: "/main-multi-page-bg-video-youtube-dark",
            text: "BG Video Youtube",
          },
          { href: "/main-multi-page-dark-dark", text: "Dark Version" },
        ],
      },
      {
        title: "One Page",
        links: [
          { href: "/main-one-page-dark", text: "Main Demo" },
          { href: "/main-one-page-typed-text-dark", text: "Typed Text" },
          {
            href: "/main-one-page-image-parallax-dark",
            text: "Image Parallax",
          },
          {
            href: "/main-one-page-slider-fullscreen-dark",
            text: "Slider Fullscreen",
          },
          {
            href: "/main-one-page-slider-background-dark",
            text: "Slider Background",
          },
          { href: "/main-one-page-bg-video-dark", text: "BG Video HTML5" },
          {
            href: "/main-one-page-bg-video-youtube-dark",
            text: "BG Video Youtube",
          },
          { href: "/main-one-page-dark", text: "Dark Version" },
        ],
      },
    ],
  },
  {
    title: "Pages",
    subMenu: [
      {
        title: "Group 1",
        links: [
          { href: "/main-pages-about-1-dark", text: "About Us 1" },
          { href: "/main-pages-about-2-dark", text: "About Us 2" },
          { href: "/main-pages-about-3-dark", text: "About Us 3" },
          { href: "/main-pages-services-1-dark", text: "Services 1" },
          { href: "/main-pages-services-2-dark", text: "Services 2" },
          { href: "/main-pages-services-3-dark", text: "Services 3" },
          { href: "/main-pages-clients-dark", text: "Clients" },
        ],
      },
      {
        title: "Group 2",
        links: [
          { href: "/main-pages-team-dark", text: "Team" },
          { href: "/main-pages-faq-1-dark", text: "FAQ 1" },
          { href: "/main-pages-faq-2-dark", text: "FAQ 2" },
          { href: "/main-pages-pricing-1-dark", text: "Pricing 1" },
          { href: "/main-pages-pricing-2-dark", text: "Pricing 2" },
          { href: "/main-pages-contact-1-dark", text: "Contact 1" },
          { href: "/main-pages-contact-2-dark", text: "Contact 2" },
        ],
      },
      {
        title: "Group 3",
        links: [
          { href: "/main-pages-gallery-1col-dark", text: "Gallery Col 1" },
          { href: "/main-pages-gallery-2col-dark", text: "Gallery Col 2" },
          { href: "/main-pages-gallery-3col-dark", text: "Gallery Col 3" },
          { href: "/main-pages-gallery-4col-dark", text: "Gallery Col 4" },
          { href: "/main-pages-account-dark", text: "Login / Register" },
          {
            href: "/main-pages-under-construction",
            text: "Under Construction",
          },
          { href: "/main-pages-404", text: "Error 404" },
        ],
      },
    ],
  },
  {
    title: "Elements",
    subMenu: [
      {
        links: [
          {
            href: "/main-elements-accordions-dark",
            icon: "mi-circle-add",
            text: "Accordions",
          },
          {
            href: "/main-elements-alert-messages-dark",
            icon: "mi-circle-information",
            text: "Alert Messages",
          },
          {
            href: "/main-elements-animation-dark",
            icon: "mi-play",
            text: "Animation",
          },
          {
            href: "/main-elements-bars-dark",
            icon: "mi-bar-chart",
            text: "Bars (Progress)",
          },
          {
            href: "/main-elements-buttons-dark",
            icon: "mi-link",
            text: "Buttons",
          },
          {
            href: "/main-elements-cookie-banner-dark",
            icon: "mi-flag",
            text: "Cookie Banner",
          },
          {
            href: "/main-elements-features-dark",
            icon: "mi-grid",
            text: "Feature Boxes",
          },
          {
            href: "/main-elements-forms-dark",
            icon: "mi-three-rows",
            text: "Form Fields",
          },
          {
            href: "/main-elements-grid-dark",
            icon: "mi-layout",
            text: "Grid",
          },
          {
            href: "/main-elements-icons-brands-dark",
            icon: "mi-circle",
            text: "Icons Brands",
          },
          {
            href: "/main-elements-icons-iconmonstr-dark",
            icon: "mi-favorite",
            text: "Icons Iconmonstr",
          },
          {
            href: "/main-elements-icons-Ionicons-dark",
            icon: "mi-heart",
            text: "Icons Ionicons",
          },
          {
            href: "/main-elements-icons-monoicons-dark",
            icon: "mi-sun",
            text: "Icons Monoicons",
          },
        ],
      },
      {
        links: [
          {
            href: "/main-elements-images-lazyload-dark",
            icon: "mi-image",
            text: "Images Lazyload",
          },
          {
            href: "/main-elements-lightbox-dark",
            icon: "mi-window",
            text: "Lightbox",
          },
          {
            href: "/main-elements-sliders-dark",
            icon: "mi-circle-arrow-right",
            text: "Sliders",
          },
          {
            href: "/main-elements-sliders-lazyload-dark",
            icon: "mi-circle-arrow-right",
            text: "Sliders Lazyload",
          },
          {
            href: "/main-elements-tabs-dark",
            icon: "mi-two-columns",
            text: "Tabs",
          },
          {
            href: "/main-elements-tooltips-dark",
            icon: "mi-message",
            text: "Tooltips",
          },
          {
            href: "/main-elements-typography-dark",
            icon: "mi-text",
            text: "Typography",
          },
          {
            href: "/main-elements-video-sound-dark",
            icon: "mi-webcam",
            text: "Video / Sound",
          },
          {
            href: "/main-elements-header-dark",
            icon: "mi-book",
            text: "Header Dark",
          },
          {
            href: "/main-elements-header-dark-transparent-dark",
            icon: "mi-book",
            text: "Header Dark Transp",
          },

          {
            href: "/main-elements-header-white-after-scroll-dark",
            icon: "mi-book",
            text: "Header Scroll-White",
          },
        ],
      },
    ],
  },
  {
    title: "Portfolio",
    subItems: [
      {
        title: "Boxed",
        links: [
          { href: "/main-portfolio-boxed-2col-dark", label: "2 Columns" },
          { href: "/main-portfolio-boxed-3col-dark", label: "3 Columns" },
          { href: "/main-portfolio-boxed-4col-dark", label: "4 Columns" },
        ],
      },
      {
        title: "Wide",
        links: [
          { href: "/main-portfolio-wide-2col-dark", label: "2 Columns" },
          { href: "/main-portfolio-wide-3col-dark", label: "3 Columns" },
          { href: "/main-portfolio-wide-4col-dark", label: "4 Columns" },
        ],
      },
      {
        title: "Masonry",
        links: [
          { href: "/main-portfolio-masonry-2col-dark", label: "2 Columns" },
          { href: "/main-portfolio-masonry-3col-dark", label: "3 Columns" },
          { href: "/main-portfolio-masonry-4col-dark", label: "4 Columns" },
        ],
      },
      {
        title: "Single",
        links: [
          { href: "/main-portfolio-single-1-dark/1", label: "Single 1" },
          { href: "/main-portfolio-single-2-dark/1", label: "Single 2" },
          { href: "/main-portfolio-single-3-dark/1", label: "Single 3" },
        ],
      },
    ],
  },
  {
    title: "Blog",
    subItems: [
      {
        title: "Classic",
        links: [
          {
            href: "/main-blog-classic-sidebar-left-dark",
            label: "Sidebar Left",
          },
          {
            href: "/main-blog-classic-sidebar-right-dark",
            label: "Sidebar Right",
          },
          { href: "/main-blog-classic-fullwidth-dark", label: "Fullwidth" },
        ],
      },
      {
        title: "Columns",
        links: [
          { href: "/main-blog-columns-2col-dark", label: "2 Columns" },
          { href: "/main-blog-columns-3col-dark", label: "3 Columns" },
        ],
      },
      {
        title: "Single",
        links: [
          {
            href: "/main-blog-single-sidebar-left-dark/1",
            label: "Sidebar Left",
          },
          {
            href: "/main-blog-single-sidebar-right-dark/1",
            label: "Sidebar Right",
          },
          { href: "/main-blog-single-fullwidth-dark/1", label: "Fullwidth" },
        ],
      },
    ],
  },
];

export const allHomes = [
  {
    title: "Main",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/main-one-page", text: "One Page" },
          { href: "/main-one-page-dark", text: "One Page Dark" },
          { href: "/main-multi-page", text: "Multi Page" },
          { href: "/main-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Typed Text",
        links: [
          { href: "/main-one-page-typed-text", text: "One Page" },
          { href: "/main-one-page-typed-text-dark", text: "One Page Dark" },
          { href: "/main-multi-page-typed-text", text: "Multi Page" },
          { href: "/main-multi-page-typed-text-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Image Parallax",
        links: [
          { href: "/main-one-page-image-parallax", text: "One Page" },
          { href: "/main-one-page-image-parallax-dark", text: "One Page Dark" },
          { href: "/main-multi-page-image-parallax", text: "Multi Page" },
          {
            href: "/main-multi-page-image-parallax-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Slider Fullscreen",
        links: [
          { href: "/main-one-page-slider-fullscreen", text: "One Page" },
          {
            href: "/main-one-page-slider-fullscreen-dark",
            text: "One Page Dark",
          },
          { href: "/main-multi-page-slider-fullscreen", text: "Multi Page" },
          {
            href: "/main-multi-page-slider-fullscreen-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Slider Background",
        links: [
          { href: "/main-one-page-slider-background", text: "One Page" },
          {
            href: "/main-one-page-slider-background-dark",
            text: "One Page Dark",
          },
          { href: "/main-multi-page-slider-background", text: "Multi Page" },
          {
            href: "/main-multi-page-slider-background-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video HTML5",
        links: [
          { href: "/main-one-page-bg-video", text: "One Page" },
          { href: "/main-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/main-multi-page-bg-video", text: "Multi Page" },
          { href: "/main-multi-page-bg-video-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "BG Video Youtube",
        links: [
          { href: "/main-one-page-bg-video-youtube", text: "One Page" },
          {
            href: "/main-one-page-bg-video-youtube-dark",
            text: "One Page Dark",
          },
          { href: "/main-multi-page-bg-video-youtube", text: "Multi Page" },
          {
            href: "/main-multi-page-bg-video-youtube-dark",
            text: "Multi Page Dark",
          },
        ],
      },
    ],
  },
  {
    title: "Bold",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/bold-one-page", text: "One Page" },
          { href: "/bold-one-page-dark", text: "One Page Dark" },
          { href: "/bold-multi-page", text: "Multi Page" },
          { href: "/bold-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Typed Text",
        links: [
          { href: "/bold-one-page-typed-text", text: "One Page" },
          { href: "/bold-one-page-typed-text-dark", text: "One Page Dark" },
          { href: "/bold-multi-page-typed-text", text: "Multi Page" },
          { href: "/bold-multi-page-typed-text-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/bold-one-page-bg-video", text: "One Page" },
          { href: "/bold-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/bold-multi-page-bg-video", text: "Multi Page" },
          { href: "/bold-multi-page-bg-video-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
  {
    title: "Brutalist",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/brutalist-one-page", text: "One Page" },
          { href: "/brutalist-one-page-dark", text: "One Page Dark" },
          { href: "/brutalist-multi-page", text: "Multi Page" },
          { href: "/brutalist-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/brutalist-one-page-bg-video", text: "One Page" },
          { href: "/brutalist-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/brutalist-multi-page-bg-video", text: "Multi Page" },
          {
            href: "/brutalist-multi-page-bg-video-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video Youtube",
        links: [
          { href: "/brutalist-one-page-bg-video-youtube", text: "One Page" },
          {
            href: "/brutalist-one-page-bg-video-youtube-dark",
            text: "One Page Dark",
          },
          {
            href: "/brutalist-multi-page-bg-video-youtube",
            text: "Multi Page",
          },
          {
            href: "/brutalist-multi-page-bg-video-youtube-dark",
            text: "Multi Page Dark",
          },
        ],
      },
    ],
  },
  {
    title: "Corporate",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/corporate-one-page", text: "One Page" },
          { href: "/corporate-one-page-dark", text: "One Page Dark" },
          { href: "/corporate-multi-page", text: "Multi Page" },
          { href: "/corporate-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Image Parallax",
        links: [
          { href: "/corporate-one-page-image-parallax", text: "One Page" },
          {
            href: "/corporate-one-page-image-parallax-dark",
            text: "One Page Dark",
          },
          { href: "/corporate-multi-page-image-parallax", text: "Multi Page" },
          {
            href: "/corporate-multi-page-image-parallax-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/corporate-one-page-bg-video", text: "One Page" },
          { href: "/corporate-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/corporate-multi-page-bg-video", text: "Multi Page" },
          {
            href: "/corporate-multi-page-bg-video-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Split Screen",
        links: [
          { href: "/corporate-one-page-split", text: "One Page" },
          { href: "/corporate-one-page-split-dark", text: "One Page Dark" },
          { href: "/corporate-multi-page-split", text: "Multi Page" },
          { href: "/corporate-multi-page-split-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
  {
    title: "Elegant",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/elegant-one-page", text: "One Page" },
          { href: "/elegant-one-page-dark", text: "One Page Dark" },
          { href: "/elegant-multi-page", text: "Multi Page" },
          { href: "/elegant-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/elegant-one-page-bg-video", text: "One Page" },
          { href: "/elegant-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/elegant-multi-page-bg-video", text: "Multi Page" },
          {
            href: "/elegant-multi-page-bg-video-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Split Screen",
        links: [
          { href: "/elegant-one-page-split", text: "One Page" },
          { href: "/elegant-one-page-split-dark", text: "One Page Dark" },
          { href: "/elegant-multi-page-split", text: "Multi Page" },
          { href: "/elegant-multi-page-split-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
  {
    title: "Fancy",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/fancy-one-page", text: "One Page" },
          { href: "/fancy-one-page-dark", text: "One Page Dark" },
          { href: "/fancy-multi-page", text: "Multi Page" },
          { href: "/fancy-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Image Parallax",
        links: [
          { href: "/fancy-one-page-image-parallax", text: "One Page" },
          {
            href: "/fancy-one-page-image-parallax-dark",
            text: "One Page Dark",
          },
          { href: "/fancy-multi-page-image-parallax", text: "Multi Page" },
          {
            href: "/fancy-multi-page-image-parallax-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/fancy-one-page-bg-video", text: "One Page" },
          { href: "/fancy-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/fancy-multi-page-bg-video", text: "Multi Page" },
          { href: "/fancy-multi-page-bg-video-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
  {
    title: "Gradient",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/gradient-one-page", text: "One Page" },
          { href: "/gradient-one-page-dark", text: "One Page Dark" },
          { href: "/gradient-multi-page", text: "Multi Page" },
          { href: "/gradient-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Image Parallax 1",
        links: [
          { href: "/gradient-one-page-image-parallax-1", text: "One Page" },
          {
            href: "/gradient-one-page-image-parallax-1-dark",
            text: "One Page Dark",
          },
          { href: "/gradient-multi-page-image-parallax-1", text: "Multi Page" },
          {
            href: "/gradient-multi-page-image-parallax-1-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Image Parallax 2",
        links: [
          { href: "/gradient-one-page-image-parallax-2", text: "One Page" },
          {
            href: "/gradient-one-page-image-parallax-2-dark",
            text: "One Page Dark",
          },
          { href: "/gradient-multi-page-image-parallax-2", text: "Multi Page" },
          {
            href: "/gradient-multi-page-image-parallax-2-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/gradient-one-page-bg-video", text: "One Page" },
          { href: "/gradient-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/gradient-multi-page-bg-video", text: "Multi Page" },
          {
            href: "/gradient-multi-page-bg-video-dark",
            text: "Multi Page Dark",
          },
        ],
      },
    ],
  },
  {
    title: "Modern",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/modern-one-page", text: "One Page" },
          { href: "/modern-one-page-dark", text: "One Page Dark" },
          { href: "/modern-multi-page", text: "Multi Page" },
          { href: "/modern-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Image Parallax 1",
        links: [
          { href: "/modern-one-page-image-parallax-1", text: "One Page" },
          {
            href: "/modern-one-page-image-parallax-1-dark",
            text: "One Page Dark",
          },
          { href: "/modern-multi-page-image-parallax-1", text: "Multi Page" },
          {
            href: "/modern-multi-page-image-parallax-1-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Image Parallax 2",
        links: [
          { href: "/modern-one-page-image-parallax-2", text: "One Page" },
          {
            href: "/modern-one-page-image-parallax-2-dark",
            text: "One Page Dark",
          },
          { href: "/modern-multi-page-image-parallax-2", text: "Multi Page" },
          {
            href: "/modern-multi-page-image-parallax-2-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "Typed Text",
        links: [
          { href: "/modern-one-page-typed-text", text: "One Page" },
          { href: "/modern-one-page-typed-text-dark", text: "One Page Dark" },
          { href: "/modern-multi-page-typed-text", text: "Multi Page" },
          {
            href: "/modern-multi-page-typed-text-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/modern-one-page-bg-video", text: "One Page" },
          { href: "/modern-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/modern-multi-page-bg-video", text: "Multi Page" },
          { href: "/modern-multi-page-bg-video-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
  {
    title: "Slick",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/slick-one-page", text: "One Page" },
          { href: "/slick-one-page-dark", text: "One Page Dark" },
          { href: "/slick-multi-page", text: "Multi Page" },
          { href: "/slick-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Split Screen",
        links: [
          { href: "/slick-one-page-split", text: "One Page" },
          { href: "/slick-one-page-split-dark", text: "One Page Dark" },
          { href: "/slick-multi-page-split", text: "Multi Page" },
          { href: "/slick-multi-page-split-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
  {
    title: "Strong",
    links: [
      {
        title: "Main Demo",
        links: [
          { href: "/strong-one-page", text: "One Page" },
          { href: "/strong-one-page-dark", text: "One Page Dark" },
          { href: "/strong-multi-page", text: "Multi Page" },
          { href: "/strong-multi-page-dark", text: "Multi Page Dark" },
        ],
      },
      {
        title: "Image Parallax",
        links: [
          { href: "/strong-one-page-image-parallax", text: "One Page" },
          {
            href: "/strong-one-page-image-parallax-dark",
            text: "One Page Dark",
          },
          { href: "/strong-multi-page-image-parallax", text: "Multi Page" },
          {
            href: "/strong-multi-page-image-parallax-dark",
            text: "Multi Page Dark",
          },
        ],
      },
      {
        title: "BG Video",
        links: [
          { href: "/strong-one-page-bg-video", text: "One Page" },
          { href: "/strong-one-page-bg-video-dark", text: "One Page Dark" },
          { href: "/strong-multi-page-bg-video", text: "Multi Page" },
          { href: "/strong-multi-page-bg-video-dark", text: "Multi Page Dark" },
        ],
      },
    ],
  },
];
